const ArtistTemplates = require('../artist/Templates.jsx');
const CertificateTemplates = require('../certificate/Templates.jsx');
const ConsignmentTemplates = require('../consignment/Templates.jsx');
const InvoiceTemplates = require('../invoice/Templates.jsx');
const MosaicTemplates = require('../mosaic/Templates.jsx');
const OfferTemplates = require('../offer/Templates.jsx');
const PricelistTemplates = require('../pricelist/Templates.jsx');
const TearsheetTemplates = require('../tearsheet/Templates.jsx');

const Templates = {
    bios: ArtistTemplates,
    certificates: CertificateTemplates,
    consignments: ConsignmentTemplates,
    invoices: InvoiceTemplates,
    mosaics: MosaicTemplates,
    offers: OfferTemplates,
    pricelists: PricelistTemplates,
    tearsheets: TearsheetTemplates
};

module.exports = Templates;